"use client";

import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import React, { Suspense } from "react";

import { LazyLoggedOutSignUpMiniDrawer } from "./LazyLoggedOutSignUpMiniDrawer";

// This drawer will be used in discover and category pages only.
export const VisitorLoggedOutSignUpMiniDrawer: React.FC = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const isSSR = useIsSSR();

  if (isLoggedInRetailer || isSSR) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <LazyLoggedOutSignUpMiniDrawer />
    </Suspense>
  );
};
